export const DebugComponent = ({error}: {error:any}) => {
	console.log(error)
	return <></>
}